module.exports = __webpack_public_path__ + "static/media/delete.d27cbcce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/delete.svg
// module id = 173
// module chunks = 0